<!--
Support & Wellbeing screen.
Contains components for rendering the select options and the content based on the selection made
@author dgm11b
-->

<template>
    <div id="contain" class="container">
        <Nav name="Support &amp; Wellbeing" :back="true" :home="false"/>
        <div class="container p-3 pb-0">
            <p class="fw-bold blue-text">There are many support services available at the university. We can help guide you to the right place whenever you may need some help.</p>
        </div>
        <WellbeingSelect 
            @selection="updateContent"
        />
        <WellbeingContent
            :content="content"
        />
        <div id="pusher"></div>
        <Footer active="wellbeing"/>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import Nav from '@/components/Navbar.vue'
import WellbeingSelect from '@/components/wellbeing/WellbeingSelect.vue'
import WellbeingContent from '@/components/wellbeing/WellbeingContent.vue'
import Footer from '@/components/FooterMenu.vue'

const content = ref([])

function updateContent(selection) {
    content.value = selection
}


</script>

<style lang="scss" scoped>
/* Overriding default 1rem (16px) margin-bottom */
p {
    margin-bottom: 12px;
}
</style>